import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, map, takeUntil } from 'rxjs';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @Input()
  customBreadcrumbsArray: BreadcrumbDefinition[] = [];
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public p: ThisPlatform,
    public router: Router,
    private breadcrumbService: BreadcrumbService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$
      .pipe(
        map((e) => this.setLabels(e)),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  setLabels(breadcrumbs: BreadcrumbDefinition[]): BreadcrumbDefinition[] {
    for (const breadcrumb of breadcrumbs) {
      let label: string;
      if (typeof breadcrumb.label === 'function') {
        label = breadcrumb.label();
      } else {
        label = breadcrumb.label;
      }

      breadcrumb.label = this.translate.instant(label);
    }

    return breadcrumbs;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
